import { module as modujs } from "modujs";

import Flickity from "flickity";

import "flickity-fade";
import "flickity-as-nav-for";

export default class extends modujs {
	constructor(m) {
		super(m);

		this._previousHandlers = new Map();
		this._nextHandlers = new Map();
		this._resizeHandler = null;
	}

	shouldInitialize() {
		if (this.el.children.length === 0) return false;

		const containerWidth = this.el.offsetWidth;
		const cells = this.el.querySelectorAll(".o-carousel_cell");

		let totalCellsWidth = 0;
		cells.forEach((cell) => {
			totalCellsWidth += cell.offsetWidth;
		});

		return totalCellsWidth > containerWidth;
	}

	_handleResize() {
		const required = this.shouldInitialize();
		const active = !!this.flkty;

		if (required && !active) {
			this._actualInit();
		} else if (!required && active) {
			this.destroy();
			this.init();
		} else if (active) {
			this.flkty.resize();
		}
	}

	_actualInit() {
		this.flkty = new Flickity(this.el, JSON.parse(this.getData("config")));
		this.flkty.resize();

		const viewport = this.flkty.viewport;
		const currentHeightString = viewport.style.height;
		if (currentHeightString) {
			const currentHeight = parseFloat(currentHeightString);

			const newHeight = currentHeight + 10;

			viewport.style.height = `${newHeight}px`;
		}

		this.id = this.el.getAttribute("data-module-flickity");

		this.$prevBtns = document.querySelectorAll('.o-carousel_actions[data-flickity-for="' + this.id + '"] .o-carousel_btn.-prev');
		this.$prevBtns.forEach((element) => {
			let _previousHandler = this.previous.bind(this);
			this._previousHandlers.set(element, _previousHandler);
			element.addEventListener("click", _previousHandler);
		});

		this.$nextBtns = document.querySelectorAll('.o-carousel_actions[data-flickity-for="' + this.id + '"] .o-carousel_btn.-next');
		this.$nextBtns.forEach((element) => {
			let _nextHandler = this.next.bind(this);
			this._nextHandlers.set(element, _nextHandler);
			element.addEventListener("click", _nextHandler);
		});

		this.flkty.on("staticClick", (event, pointer, cellElement, cellIndex) => this.select(event, pointer, cellElement, cellIndex));
		this.flkty.on("change", (index) => this.change(index));
		this.flkty.on("dragStart", () => (this.flkty.slider.style.pointerEvents = "none"));
		this.flkty.on("dragEnd", () => (this.flkty.slider.style.pointerEvents = "auto"));

		this.change(this.flkty.selectedIndex);
	}

	init() {
		this._resizeHandler = this._handleResize.bind(this);
		window.addEventListener("resize", this._resizeHandler);

		if (!this.shouldInitialize()) {
			return;
		}

		this._actualInit();
	}

	select(event, pointer, cellElement, cellIndex) {
		if (!this.flkty) return;
		this.flkty.select(cellIndex, false, false);
	}

	change(index) {
		if (!this.flkty) return;

		if (!this.flkty.options.wrapAround) {
			this.$nextBtns.forEach(($button) => {
				$button.classList.remove("is-disabled");
			});

			this.$prevBtns.forEach(($button) => {
				$button.classList.remove("is-disabled");
			});

			if (index == 0) {
				this.$prevBtns.forEach(($button) => {
					$button.classList.add("is-disabled");
				});
			}

			if (this.flkty.slides.length - 1 == index) {
				this.$nextBtns.forEach(($button) => {
					$button.classList.add("is-disabled");
				});
			}
		}
	}

	previous() {
		if (!this.flkty) return;
		this.flkty.previous();
		this.flkty.stopPlayer();
	}

	next() {
		if (!this.flkty) return;
		this.flkty.next();
		this.flkty.stopPlayer();
	}

	destroy() {
		if (this._resizeHandler) {
			window.removeEventListener("resize", this._resizeHandler);
			this._resizeHandler = null;
		}

		this._previousHandlers.forEach((handler, element) => {
			element.removeEventListener("click", handler);
		});
		this._previousHandlers.clear();

		this._nextHandlers.forEach((handler, element) => {
			element.removeEventListener("click", handler);
		});
		this._nextHandlers.clear();

		if (this.flkty) {
			this.flkty.destroy();
			this.flkty = null;
		}
	}
}
